import { type ReactNode } from "react";

import styles from "./section.module.css";

export type BackgroundVariant = "purple-cyan" | "purple-pink" | "blue-cyan" | "default";

interface SectionProps {
    children: ReactNode;
    variant?: BackgroundVariant;
    id?: string;
    className?: string;
    withGlowOrbs?: boolean;
}

export const Section = ({ children, variant = "default", id, className = "", withGlowOrbs = true }: SectionProps) => {
    const sectionClasses = [styles.section, styles[variant], className].filter(Boolean).join(" ");

    return (
        <section className={sectionClasses} id={id}>
            <div className={styles.content}>
                {children}
                {withGlowOrbs && (
                    <>
                        <div className={styles.glowOrb1} />
                        <div className={styles.glowOrb2} />
                    </>
                )}
            </div>
        </section>
    );
};
